<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
<div class="page-indicator">
    <div *ngIf="serviceFlag && claimsDataService.lossCauseTypesLoaded" class="claims-track-page-title-wrap claims-track-page-title--overview">
        All Updates
        <small class="claims-track-company">
            <strong style="text-transform:uppercase;">{{claimsDataService.getLossCause(claimInfo.lossCause)}}</strong>
            ({{claimInfo.claimNumber}})
            <strong style="text-transform:uppercase;">{{claimInfo.claimState}}</strong>
            <span *ngIf="claimInfo.incidentOnly">(Record Only)</span>
        </small>
        <small class="claims-track-number">Incident date: {{claimInfo.lossDate| date:'MM/dd/yyyy'}}</small>
    </div>
</div>
<div class="content-container-light-blue bolt-space-bottom-sm">
    <main class="content-container-light-blue__inner" role="main">
        <article *ngFor="let event of claimEventsFiltered">
            <div class="claims-track-claim-content__text-box">
                <p>
                    <em>{{event.eventName}} {{event.eventDate| date:'MM/dd/yyyy'}}</em>
                    <a *ngIf="event.eventType === 'claimReceived' || event.eventType === 'claimClosed'" (click)="navigateToIncidentDetails()" title="See Details"
                        class="link-arrow-orange js-see-details" style="margin-bottom: 5px;margin-left: 5px; display: inline-block;">See
                        Details
                    </a>
                    <a *ngIf="event.eventType === 'paymentIssued'" (click)="navigateToPayments()" title="See Details" class="link-arrow-orange js-see-details"
                        style="margin-bottom: 5px;margin-left: 5px; display: inline-block;">See Details</a>
                </p>
                <p>{{event.eventDescription}}</p>
            </div>
        </article>
    </main>
</div>
<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
